import { render } from "./AppPaletteFillCard.vue?vue&type=template&id=b3ad5660&scoped=true&ts=true"
import script from "./AppPaletteFillCard.vue?vue&type=script&lang=ts"
export * from "./AppPaletteFillCard.vue?vue&type=script&lang=ts"

import "./AppPaletteFillCard.vue?vue&type=style&index=0&id=b3ad5660&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3ad5660"]])

export default __exports__